import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Text = styled.p`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  margin: 0;

  ${props => props.cancelled && `
    color: ${THEME.lightGrey};
    text-decoration-line: line-through;
    text-decoration-color: ${THEME.red};
  `}
`;
